export default __webpack_public_path__ + "static/logo-agenda-blue-ada4fef0b835ceadd9927ecd04f99804.svg";